import * as React from 'react';
import { HamburgerMenuIcon } from '@radix-ui/react-icons';
import { DropdownMenu } from '@radix-ui/themes';
import { useLogout } from 'src/hooks/api/fetchApi';
import Button from './Button';

interface IProps {}

const HamburgerMenu: React.FC<IProps> = ({}) => {
  const logout = useLogout();

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger>
        <Button>
          <HamburgerMenuIcon />
        </Button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content>
        <DropdownMenu.Item onClick={() => logout()}>Logout</DropdownMenu.Item>
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
};

export default HamburgerMenu;
